var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.titleLabel,
        icon: _vm.titleIcon,
        noReturn: "",
        pageClass: "rtp_details",
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          !_vm.details.id || _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "div",
                { staticClass: "ml-3 mr-3" },
                [
                  _c(
                    "b-row",
                    { attrs: { "align-h": "start" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "4", sm: "3", md: "2", xl: "1" } },
                        [
                          _c("back-button", {
                            attrs: { returnUrl: _vm.returnUrl },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          attrs: { cols: "4", sm: "3", md: "2", xl: "1" },
                          on: {
                            click: function ($event) {
                              return _vm.seeDetails()
                            },
                          },
                        },
                        [
                          _c("b-button", { staticClass: "back-button" }, [
                            _c("i", {
                              staticClass: "fa-solid fa-rotate-right fs-14px",
                            }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.canSeePaymentDetails && _vm.payments.length
                        ? _c(
                            "b-col",
                            { attrs: { cols: "4", sm: "3", md: "2", xl: "1" } },
                            [
                              _c(
                                "b-button-group",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "rtpDetailsGroupBtn",
                                      attrs: {
                                        variant:
                                          _vm.tabName === 0 ? "primary" : "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.tabName = 0
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("common.request_to_pay_tab")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "rtpDetailsGroupBtn",
                                      attrs: {
                                        variant:
                                          _vm.tabName === 1 ? "primary" : "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.tabName = 1
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.payment_tab"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    {
                      staticClass: "mt-3",
                      attrs: { "nav-class": "d-none" },
                      model: {
                        value: _vm.tabName,
                        callback: function ($$v) {
                          _vm.tabName = $$v
                        },
                        expression: "tabName",
                      },
                    },
                    [
                      _c(
                        "b-tab",
                        [
                          _vm.details.Attachments &&
                          _vm.details.Attachments.length
                            ? _c(
                                "form-accordion",
                                {
                                  attrs: {
                                    title: _vm.$t("attachments.doc_sent_list"),
                                    isTitleUpperCase: false,
                                  },
                                },
                                [
                                  _c("document-list", {
                                    attrs: {
                                      documents: _vm.details.Attachments,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showOtherDebtors() && _vm.otherRTP.length > 1
                            ? _c(
                                "form-accordion",
                                {
                                  attrs: {
                                    title: _vm.$t("common.rqst_fr_gr"),
                                    isTitleUpperCase: false,
                                  },
                                },
                                [
                                  _c("transactions-list", {
                                    attrs: {
                                      filterBy: "",
                                      itemListStyle: "border-radius:0;",
                                      actualMessageId: _vm.details.id,
                                      messages: _vm.otherRTP,
                                      randomId: _vm.randomId,
                                      serviceId: _vm.services.PAYMENTS,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showOtherDebtors() && _vm.otherRTP.length > 1
                            ? _c("hr", { staticClass: "mx-auto" })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t("common.request_details"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _vm.details.endToEndId ||
                              _vm.details.msgId ||
                              _vm.details.uri
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _vm.details.msgId
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t("filter.msgId"),
                                                    colLabelSize: 4,
                                                    colInputSize: 8,
                                                    inputValue:
                                                      _vm.details.msgId,
                                                    labelClass: "mb-0",
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _vm.details.endToEndId
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t("common.invc_ref"),
                                                    colLabelSize: 4,
                                                    colInputSize: 8,
                                                    inputValue:
                                                      _vm.details.endToEndId,
                                                    labelClass: "mb-0",
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.details.uri &&
                                      _vm.details.uri.startsWith("REQ/ ")
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: { xl: "3", cols: "3" },
                                            },
                                            [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t("common.uri"),
                                                    colLabelSize: 4,
                                                    colInputSize: 8,
                                                    inputId: "inputUri",
                                                    inputValue:
                                                      _vm.details.uri.substring(
                                                        5,
                                                        _vm.details.uri.length
                                                      ),
                                                    labelClass: "mb-0",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "tooltip-info",
                                                      attrs: {
                                                        slot: "afterInput",
                                                      },
                                                      slot: "afterInput",
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "fa-duotone fa-file-text cursor text-info fs-20px ml-5px",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.copyToClipboard(
                                                                _vm.details.uri.substring(
                                                                  5,
                                                                  _vm.details
                                                                    .uri.length
                                                                )
                                                              )
                                                            },
                                                            mouseout: function (
                                                              $event
                                                            ) {
                                                              return _vm.copyToClipboardReset()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "tooltiptext",
                                                              attrs: {
                                                                id: "copyUri",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "common.copy_to_clipboard"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c("b-col", {
                                            attrs: { xl: "3", cols: "3" },
                                          }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _vm.showAcceptModifyReason()
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c("form-write-group-label-input", {
                                            attrs: {
                                              inputLabel: _vm.$t("common.rsn"),
                                              colLabelSize: 4,
                                              colInputSize: 8,
                                              maxLength: 140,
                                              labelClass: "mb-0",
                                              tooltipLabel: _vm.$t(
                                                "requestToPay.modify_reason_creditor"
                                              ),
                                            },
                                            model: {
                                              value: _vm.details.reason,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.details,
                                                  "reason",
                                                  $$v
                                                )
                                              },
                                              expression: "details.reason",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm.showAcceptModifyReasonValidated()
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c("form-read-group-label-input", {
                                            attrs: {
                                              inputLabel: _vm.$t("common.rsn"),
                                              colLabelSize: 4,
                                              colInputSize: 8,
                                              inputValue:
                                                _vm.details
                                                  .acceptedRemittanceInformation,
                                              labelClass: "mb-0",
                                              tooltipLabel:
                                                _vm.concatenatedDateReasonText(
                                                  _vm.$t("common.rsn_ask")
                                                ),
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm.showAcceptModifyReasonCreditor()
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c("form-read-group-label-input", {
                                            attrs: {
                                              inputLabel: _vm.$t("common.rsn"),
                                              colLabelSize: 4,
                                              colInputSize: 8,
                                              inputValue: _vm.details
                                                .acceptedRemittanceInformation
                                                ? _vm.details
                                                    .acceptedRemittanceInformation
                                                : _vm.details.reason,
                                              labelClass: "mb-0",
                                              tooltipLabel: _vm.$t(
                                                "requestToPay.modify_reason_debtor"
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c("form-read-group-label-input", {
                                            attrs: {
                                              inputLabel: _vm.$t("common.rsn"),
                                              colLabelSize: 4,
                                              colInputSize: 8,
                                              inputValue: _vm.details
                                                .acceptedRemittanceInformation
                                                ? _vm.details
                                                    .acceptedRemittanceInformation
                                                : _vm.details.reason,
                                              labelClass: "mb-0",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  _vm.showAcceptModifyAmount()
                                    ? _c(
                                        "b-col",
                                        { attrs: { xl: "3", cols: "3" } },
                                        [
                                          _c("form-write-group-label-input", {
                                            attrs: {
                                              inputLabel: _vm.$t(
                                                "common.amnt_ttl_rtp"
                                              ),
                                              placeholderValue:
                                                _vm.$t("common.amnt_ttl_rtp") +
                                                " " +
                                                _vm.zoneCodeToSign(),
                                              isMandatory: "",
                                              isNotZero: "",
                                              inputType: "number",
                                              colLabelSize: 4,
                                              colInputSize: 8,
                                              labelClass: "mb-0",
                                              tooltipLabel: _vm.$t(
                                                "requestToPay.modify_amount_creditor"
                                              ),
                                              specificErrorIndicator:
                                                _vm.amountError,
                                              specificMessage:
                                                _vm.amountErrorMessage,
                                            },
                                            on: {
                                              blur: _vm.changeDebtorsAmount,
                                            },
                                            model: {
                                              value: _vm.details.amount,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.details,
                                                  "amount",
                                                  $$v
                                                )
                                              },
                                              expression: "details.amount",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm.showAcceptModifyAmountValided()
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c("form-read-group-label-input", {
                                            attrs: {
                                              inputLabel: _vm.$t(
                                                "common.amnt_ttl_accept"
                                              ),
                                              inputValue:
                                                _vm.details.acceptedAmount +
                                                " " +
                                                _vm.zoneCodeToSign(),
                                              colLabelSize: 4,
                                              colInputSize: 8,
                                              labelClass: "mb-0",
                                              tooltipLabel:
                                                _vm.concatenatedDateAmountText(
                                                  _vm.$t("common.amnt_ttl_ask")
                                                ) +
                                                " " +
                                                _vm.zoneCodeToSign(),
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm.showAcceptModifyAmountCreditor()
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c(
                                            "b-row",
                                            { staticClass: "align-items-end" },
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "11" } },
                                                [
                                                  _c(
                                                    "form-read-group-label-input",
                                                    {
                                                      attrs: {
                                                        inputLabel:
                                                          _vm.$t(
                                                            "common.amnt_ttl"
                                                          ),
                                                        inputValue:
                                                          _vm.details.amount +
                                                          " " +
                                                          _vm.zoneCodeToSign(),
                                                        colLabelSize: 4,
                                                        colInputSize: 8,
                                                        labelClass: "mb-0",
                                                        tooltipLabel: _vm.$t(
                                                          "requestToPay.modify_amount_debtor"
                                                        ),
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c("form-read-group-label-input", {
                                            attrs: {
                                              inputLabel: _vm.details
                                                .installments.length
                                                ? _vm.$t("common.amnt_ttl")
                                                : _vm.details.creditNoteAmount
                                                ? _vm.$t("common.amnt_crdt_nt")
                                                : _vm.$t("common.amnt_ttl"),
                                              colLabelSize: 4,
                                              colInputSize: 8,
                                              inputValue:
                                                (_vm.details.creditNoteAmount
                                                  ? _vm.details.creditNoteAmount
                                                  : _vm.details.amount) +
                                                " " +
                                                _vm.zoneCodeToSign(),
                                              labelClass: "mb-0",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { xl: "3", cols: "3" },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t(
                                            "common.status.status_label"
                                          ),
                                          colLabelSize: 4,
                                          colInputSize: 8,
                                          inputValue: _vm.getStatusLabel(
                                            _vm.details.status
                                          ),
                                          labelClass: "mb-0",
                                          tooltipLabel: _vm.getStatusReason(
                                            _vm.details.status
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  false
                                    ? _c("b-col", {
                                        attrs: { xl: "3", cols: "3" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { xl: "3", cols: "3" },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel:
                                            _vm.$t("common.rqst_date"),
                                          colLabelSize: 4,
                                          colInputSize: 8,
                                          inputValue:
                                            _vm.$options.filters.formatDateTime(
                                              _vm.details.dateTime
                                            ),
                                          labelClass: "mb-0",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { xl: "3", cols: "3" },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel:
                                            _vm.$t("common.date_expr"),
                                          colLabelSize: 4,
                                          colInputSize: 8,
                                          inputValue:
                                            _vm.$options.filters.formatDateTime(
                                              _vm.details
                                                .requestedExpirationDate
                                            ),
                                          labelClass: "mb-0",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.showAcceptModifyDate() &&
                                  !_vm.details.installments.length
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c(
                                            "datetime-picker-custom",
                                            {
                                              attrs: {
                                                isMandatory: "",
                                                disablePastDates: "",
                                                format: "DD/MM/YYYY H:i:s",
                                                customInputClass:
                                                  "form-control",
                                                customLabelClass: "mb-0",
                                                inputLabel:
                                                  _vm.$t("common.exec_date"),
                                                maxLength: 19,
                                                placeholderValue: _vm.$t(
                                                  "common.datetime_picker_empty_date"
                                                ),
                                                tooltipLabel: _vm.$t(
                                                  "requestToPay.modify_date_creditor"
                                                ),
                                                inputIcon:
                                                  "fa-solid fa-calendar pl-2",
                                              },
                                              model: {
                                                value:
                                                  _vm.requestedExecutionDateFormat,
                                                callback: function ($$v) {
                                                  _vm.requestedExecutionDateFormat =
                                                    $$v
                                                },
                                                expression:
                                                  "requestedExecutionDateFormat",
                                              },
                                            },
                                            [
                                              _vm.hasPastExecutionDate &&
                                              !_vm.details.installments.length
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa-duotone fa-warning cursor text-warning fs-20px ml-5px",
                                                    attrs: {
                                                      slot: "afterInput",
                                                      title: _vm.$t(
                                                        "common.exec_date_exprd"
                                                      ),
                                                    },
                                                    slot: "afterInput",
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm.showAcceptModifyDateValidated()
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c(
                                            "form-read-group-label-input",
                                            {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "common.exec_date_accept"
                                                ),
                                                inputIcon:
                                                  "fa-solid fa-calendar text-info",
                                                inputValue:
                                                  _vm.$options.filters.formatDateTime(
                                                    _vm.details
                                                      .acceptedRequestedExecutionDatetime
                                                  ),
                                                colLabelSize: 4,
                                                colInputSize: 8,
                                                inputType: "date",
                                                disablePastDates: "",
                                                labelClass: "mb-0",
                                                tooltipLabel:
                                                  _vm.$t(
                                                    "common.exec_date_ask"
                                                  ) +
                                                  " : " +
                                                  _vm.$options.filters.formatDateTime(
                                                    _vm.details
                                                      .requestedExecutionDate
                                                  ),
                                              },
                                            },
                                            [
                                              _vm.hasPastExecutionDate &&
                                              !_vm.details.installments.length
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa-duotone fa-warning cursor text-warning fs-17px ml-5px",
                                                    attrs: {
                                                      slot: "afterInput",
                                                      title: _vm.$t(
                                                        "common.exec_date_exprd"
                                                      ),
                                                    },
                                                    slot: "afterInput",
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm.showAcceptModifyDateCreditor() &&
                                      !_vm.details.installments.length
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c(
                                            "form-read-group-label-input",
                                            {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.exec_date"),
                                                inputIcon:
                                                  "fa-solid fa-calendar text-info",
                                                inputValue:
                                                  _vm.$options.filters.formatDateTime(
                                                    _vm.details
                                                      .requestedExecutionDate
                                                  ),
                                                colLabelSize: 4,
                                                colInputSize: 8,
                                                inputType: "date",
                                                disablePastDates: "",
                                                labelClass: "mb-0",
                                                tooltipLabel: _vm.$t(
                                                  "requestToPay.modify_date_debtor"
                                                ),
                                              },
                                            },
                                            [
                                              _vm.hasPastExecutionDate &&
                                              !_vm.details.installments.length
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa-duotone fa-warning cursor text-warning fs-17px ml-5px",
                                                    attrs: {
                                                      slot: "afterInput",
                                                      title: _vm.$t(
                                                        "common.exec_date_exprd"
                                                      ),
                                                    },
                                                    slot: "afterInput",
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : !_vm.details.installments.length
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _c(
                                            "form-read-group-label-input",
                                            {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("common.exec_date"),
                                                colLabelSize: 4,
                                                colInputSize: 8,
                                                inputValue:
                                                  _vm.$options.filters.formatDateTime(
                                                    _vm.details
                                                      .requestedExecutionDate
                                                  ),
                                                labelClass: "mb-0",
                                              },
                                            },
                                            [
                                              _vm.hasPastExecutionDate &&
                                              !_vm.details.installments.length
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa-duotone fa-warning cursor text-warning fs-17px ml-5px",
                                                    attrs: {
                                                      slot: "afterInput",
                                                      title: _vm.$t(
                                                        "common.exec_date_exprd"
                                                      ),
                                                    },
                                                    slot: "afterInput",
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c("b-col", {
                                        staticClass: "form-group",
                                        attrs: { cols: "3" },
                                      }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.details.paymentRequest
                                ? _c(
                                    "b-row",
                                    [
                                      _vm.details.paymentRequest.debtorIban
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: { cols: "3" },
                                            },
                                            [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "common.debtor_ibn_used"
                                                    ),
                                                    colLabelSize: 4,
                                                    colInputSize: 8,
                                                    inputValue:
                                                      _vm.details.paymentRequest
                                                        .debtorIban,
                                                    labelClass: "mb-0",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.details.paymentRequest.status
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: { cols: "3" },
                                            },
                                            [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "common.payment_status"
                                                    ),
                                                    colLabelSize: 4,
                                                    colInputSize: 8,
                                                    inputValue: _vm.$t(
                                                      "common.status.payment." +
                                                        _vm.details
                                                          .paymentRequest.status
                                                    ),
                                                    labelClass: "mb-0",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.canSeePain001
                                        ? _c(
                                            "b-col",
                                            { attrs: { cols: "3" } },
                                            [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel:
                                                      _vm.$t("common.flux_out"),
                                                    colLabelSize: 4,
                                                    colInputSize: 8,
                                                    inputValue:
                                                      _vm.details.paymentRequest
                                                        .format.out.type,
                                                    labelClass: "mb-0",
                                                  },
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.seeXml(
                                                        _vm.details
                                                          .paymentRequest.format
                                                          .out,
                                                        "payment",
                                                        "see"
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.seeXml(
                                                        _vm.details
                                                          .paymentRequest.format
                                                          .out,
                                                        "payment",
                                                        "download"
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.details.paymentRequest === "1" &&
                                      this.receivedPayments &&
                                      this.receivedPayments.length <= 1
                                        ? _c("b-col", {
                                            staticClass: "form-group",
                                            attrs: { xl: "3", cols: "3" },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "3", cols: "3" },
                                        },
                                        [
                                          _vm.details.paymentRequest === "1" &&
                                          this.receivedPayments &&
                                          this.receivedPayments.length <= 1 &&
                                          _vm.payments.length
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "administration.transaction_identifier"
                                                    ),
                                                    colLabelSize: 4,
                                                    colInputSize: 8,
                                                    inputValue: _vm.payments[0]
                                                      .TransactionId
                                                      ? _vm.payments[0]
                                                          .TransactionId
                                                      : "-",
                                                    labelClass: "mb-0",
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.details.paymentRequest === "1" &&
                                      this.receivedPayments &&
                                      this.receivedPayments.length <= 1 &&
                                      _vm.payments.length
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: { cols: "3" },
                                            },
                                            [
                                              _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "common.payment_status"
                                                    ),
                                                    colLabelSize: 4,
                                                    colInputSize: 8,
                                                    inputValue: _vm.$t(
                                                      "common.status.payment." +
                                                        _vm.payments[0].status
                                                    ),
                                                    labelClass: "mb-0",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.details.installments.length
                            ? _c(
                                "form-accordion",
                                {
                                  key: _vm.installmentRefresh,
                                  attrs: {
                                    title: _vm.$t(
                                      "common.request_installments_proposed"
                                    ),
                                    isTitleUpperCase: false,
                                  },
                                },
                                [
                                  _vm.details.installments.length
                                    ? _c("b-table", {
                                        key: _vm.keyTableInstallments,
                                        staticClass: "table-condensed",
                                        class:
                                          !_vm.canSeePaymentDetails ||
                                          (this.receivedPayments &&
                                            this.receivedPayments.length <= 1)
                                            ? "w-50"
                                            : "px-5",
                                        attrs: {
                                          hover: "",
                                          responsive: "",
                                          items: _vm.details.installments,
                                          fields: _vm.installmentsFields,
                                          "select-mode": "single",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "cell(Number)",
                                              fn: function (data) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(data.index + 1)
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                            {
                                              key: "cell(Date)",
                                              fn: function (data) {
                                                return [
                                                  _vm.showAcceptModifyDate()
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center",
                                                        },
                                                        [
                                                          _c(
                                                            "datetime-picker-custom",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  _vm.formateInstalmentDate(
                                                                    data.value
                                                                  ),
                                                                isMandatory: "",
                                                                disablePastDates:
                                                                  "",
                                                                format:
                                                                  "DD/MM/YYYY H:i:s",
                                                                customInputClass:
                                                                  "form-control",
                                                                customLabelClass:
                                                                  "mb-0",
                                                                maxLength: 19,
                                                                placeholderValue:
                                                                  _vm.$t(
                                                                    "common.datetime_picker_empty_date"
                                                                  ),
                                                                tooltipLabel:
                                                                  _vm.$t(
                                                                    "requestToPay.modify_date_creditor"
                                                                  ),
                                                                inputIcon:
                                                                  "fa-solid fa-calendar pl-2",
                                                              },
                                                              on: {
                                                                blur: _vm.changeDebtorsDate,
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.changeInstallementDates(
                                                                      $event,
                                                                      data.index
                                                                    )
                                                                  },
                                                              },
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            staticClass:
                                                              "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                                                            attrs: {
                                                              title: _vm.$t(
                                                                "requestToPay.modify_date_creditor"
                                                              ),
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm.showAcceptModifyDateCreditor()
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$options.filters.formatDateTime(
                                                                _vm.details
                                                                  .installments[
                                                                  data.index
                                                                ].Date
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                                                          attrs: {
                                                            title: _vm.$t(
                                                              "requestToPay.modify_field_quotes_debtor",
                                                              {
                                                                field:
                                                                  _vm.$t(
                                                                    "common.exec_date"
                                                                  ) +
                                                                  " " +
                                                                  (data.index +
                                                                    1),
                                                              }
                                                            ),
                                                          },
                                                        }),
                                                      ])
                                                    : _vm.showAcceptModifyInstallmentValidated()
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$options.filters.formatDateTime(
                                                                _vm.details
                                                                  .installments[
                                                                  data.index
                                                                ].Date
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _vm.details
                                                          .originalInstallments[
                                                          data.index
                                                        ].Date
                                                          ? _c("i", {
                                                              staticClass:
                                                                "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                                                              attrs: {
                                                                title:
                                                                  _vm.$t(
                                                                    "common.exec_date_ask"
                                                                  ) +
                                                                  " : " +
                                                                  _vm.$options.filters.formatDateTime(
                                                                    _vm.details
                                                                      .originalInstallments[
                                                                      data.index
                                                                    ].Date
                                                                  ),
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$options.filters.formatDateTime(
                                                              _vm.details
                                                                .installments[
                                                                data.index
                                                              ].Date
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                  _vm._v(" "),
                                                  _vm.hasPastExecutionDateInstalment(
                                                    data.item
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-warning font-weight-bold",
                                                        },
                                                        [
                                                          _c("small", [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa-duotone fa-warning cursor",
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.exec_date_exprd"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                            {
                                              key: "cell(Amount)",
                                              fn: function (data) {
                                                return [
                                                  _vm.showAcceptModifyAmount()
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center",
                                                        },
                                                        [
                                                          _vm.showAcceptModifyAmount()
                                                            ? _c(
                                                                "form-write-group-label-input",
                                                                {
                                                                  attrs: {
                                                                    isMandatory:
                                                                      "",
                                                                    disablePastDates:
                                                                      "",
                                                                    placeholderValue:
                                                                      _vm.$t(
                                                                        "common.amnt_installment_rtp"
                                                                      ) +
                                                                      " " +
                                                                      (data.index +
                                                                        1) +
                                                                      " " +
                                                                      _vm.zoneCodeToSign(),
                                                                    inputType:
                                                                      "number",
                                                                    colLabelSize: 4,
                                                                    colInputSize: 8,
                                                                    minValue: 0,
                                                                    value:
                                                                      data.value,
                                                                    labelClass:
                                                                      "mb-0",
                                                                    tooltipLabel:
                                                                      _vm.$t(
                                                                        "requestToPay.modify_amount_creditor"
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.changeInstallementAmounts(
                                                                          $event,
                                                                          data.index
                                                                        )
                                                                      },
                                                                    blur: _vm.changeDebtorsAmount,
                                                                  },
                                                                }
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            staticClass:
                                                              "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                                                            attrs: {
                                                              title: _vm.$t(
                                                                "requestToPay.modify_amount_creditor"
                                                              ),
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm.showAcceptModifyAmountCreditor()
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.details
                                                                .installments[
                                                                data.index
                                                              ].Amount +
                                                                " " +
                                                                _vm.zoneCodeToSign()
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                                                          attrs: {
                                                            title: _vm.$t(
                                                              "requestToPay.modify_field_quotes_debtor",
                                                              {
                                                                field:
                                                                  _vm.$t(
                                                                    "common.amnt_installment_rtp"
                                                                  ) +
                                                                  " " +
                                                                  (data.index +
                                                                    1),
                                                              }
                                                            ),
                                                          },
                                                        }),
                                                      ])
                                                    : _vm.showAcceptModifyInstallmentValidated()
                                                    ? _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.details
                                                                .installments[
                                                                data.index
                                                              ].Amount +
                                                                " " +
                                                                _vm.zoneCodeToSign()
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _vm.details
                                                          .originalInstallments[
                                                          data.index
                                                        ].Amount
                                                          ? _c("i", {
                                                              staticClass:
                                                                "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                                                              attrs: {
                                                                title:
                                                                  _vm.$t(
                                                                    "common.amnt_installment_rtp_ask"
                                                                  ) +
                                                                  " : " +
                                                                  _vm.details
                                                                    .originalInstallments[
                                                                    data.index
                                                                  ].Amount +
                                                                  " " +
                                                                  _vm.zoneCodeToSign(),
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.details
                                                              .installments[
                                                              data.index
                                                            ].Amount +
                                                              " " +
                                                              _vm.zoneCodeToSign()
                                                          )
                                                        ),
                                                      ]),
                                                ]
                                              },
                                            },
                                            {
                                              key: "cell(TransactionId)",
                                              fn: function (data) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.value
                                                          ? data.value
                                                          : "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                            {
                                              key: "cell(Status)",
                                              fn: function (data) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.value
                                                          ? _vm.$t(
                                                              "common.status.payment." +
                                                                data.value
                                                            )
                                                          : "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3469587780
                                        ),
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("hr", { staticClass: "mx-auto" }),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t("creation_forms.crdtr_info"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                { staticClass: "pt-1 mb-3" },
                                [
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "form-group",
                                        attrs: { xl: "3", cols: "3" },
                                      },
                                      [
                                        _c("form-read-group-label-input", {
                                          attrs: {
                                            inputLabel: _vm.$t("common.my_nme"),
                                            inputValue:
                                              _vm.details.creditorName,
                                            labelClass: "mb-0",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { xl: "3", cols: "3" },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t(
                                            "common.rtp_dbtr_ibn"
                                          ),
                                          inputValue:
                                            _vm.details.creditorBankAccount,
                                          labelClass: "mb-0",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { xl: "3", cols: "3" },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel:
                                            _vm.$t("common.my_provider"),
                                          inputValue: _vm.details.creditorBIC,
                                          labelClass: "mb-0",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr", { staticClass: "mx-auto" }),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t("creation_forms.dbtr_info"),
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                { staticClass: "pt-1 mb-3" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { xl: "3", cols: "3" },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t("common.my_nme"),
                                          inputValue: _vm.details.debtorName,
                                          labelClass: "mb-0",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { xl: "3", cols: "3" },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t(
                                            "common.rtp_dbtr_ibn"
                                          ),
                                          inputValue: _vm.details
                                            .debtorBankAccount
                                            ? _vm.details.debtorBankAccount
                                            : "-",
                                          labelClass: "mb-0",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { xl: "3", cols: "3" },
                                    },
                                    [
                                      _c("form-read-group-label-input", {
                                        attrs: {
                                          inputLabel: _vm.$t(
                                            "common.rtp_dbtr_provider"
                                          ),
                                          inputValue:
                                            _vm.details.debtorIdProvider,
                                          labelClass: "mb-0",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.details.direction === "0"
                            ? _c(
                                "b-row",
                                { staticClass: "panel-subtitle d-none" },
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "form-group" },
                                    [
                                      _vm.showInstantPayment(
                                        _vm.details.debtorBankAccount
                                      )
                                        ? _c(
                                            "b-form-checkbox",
                                            {
                                              staticClass: "mt-sm-2",
                                              attrs: {
                                                value: "1",
                                                "unchecked-value": "0",
                                                disabled:
                                                  !_vm.waitingForAnswerRTP(
                                                    _vm.details.status
                                                  ) || _vm.isInstantPayment,
                                              },
                                              model: {
                                                value:
                                                  _vm.details.instantPayment,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.details,
                                                    "instantPayment",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "details.instantPayment",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "requestToPay.is_inst_payment"
                                                    )
                                                  ) +
                                                  "\n                  " +
                                                  _vm._s(
                                                    "(" +
                                                      _vm.getBankName(
                                                        _vm.details
                                                          .debtorBankAccount
                                                      ) +
                                                      ")"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.waitingForAnswerRTP(_vm.details.status) &&
                            _vm.details.negotStatus === "10") ||
                          (_vm.waitingForAnswerRTP(_vm.details.status) &&
                            _vm.details.negotStatus === "11") ||
                          _vm.details.status === _vm.status.ACCEPTED ||
                          _vm.details.status === _vm.status.MODIFIED ||
                          _vm.details.status === _vm.status.REVOKED ||
                          _vm.details.status ===
                            _vm.status.ACCEPTED_AND_PAYED ||
                          _vm.details.status ===
                            _vm.status.ACCEPTED_AND_PAYED_INST ||
                          _vm.details.status ===
                            _vm.status.MODIFIED_AND_PAYED ||
                          _vm.details.status ===
                            _vm.status.MODIFIED_AND_PAYED_INST ||
                          _vm.details.status === _vm.status.ORDER_GENERATED ||
                          _vm.details.status === _vm.status.MADE ||
                          _vm.details.status === _vm.status.INST_MADE
                            ? _c("div", [
                                (_vm.details.amountResponse.length > 0 &&
                                  _vm.details.amountResponse !==
                                    _vm.details.amount) ||
                                (_vm.details.executionDateResponse.length > 0 &&
                                  _vm.details.requestedExecutionDate !==
                                    _vm.details.executionDateResponse)
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "transactionDetailSubHeader",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "common.orig_terms"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          [
                                            _vm.details.amountResponse.length >
                                              0 &&
                                            _vm.details.amountResponse !==
                                              _vm.details.amount
                                              ? _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "form-group",
                                                    attrs: { sm: "6" },
                                                  },
                                                  [
                                                    _c(
                                                      "form-read-group-label-input",
                                                      {
                                                        staticClass:
                                                          "panel-subtitle-detail-demande-form",
                                                        attrs: {
                                                          inputLabel:
                                                            _vm.$t(
                                                              "common.orig_amount"
                                                            ),
                                                          horizontal: "",
                                                          inputValue:
                                                            _vm.details.amount +
                                                            " " +
                                                            _vm.zoneCodeToSign(),
                                                          labelClass: "mb-0",
                                                        },
                                                      }
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.details.executionDateResponse
                                              .length > 0 &&
                                            _vm.details
                                              .requestedExecutionDate !==
                                              _vm.details.executionDateResponse
                                              ? _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "form-group",
                                                    attrs: { sm: "6" },
                                                  },
                                                  [
                                                    _c(
                                                      "form-read-group-label-input",
                                                      {
                                                        staticClass:
                                                          "panel-subtitle-detail-demande-form",
                                                        attrs: {
                                                          inputLabel: _vm.$t(
                                                            "common.exec_date_orig"
                                                          ),
                                                          horizontal: "",
                                                          inputValue: _vm._f(
                                                            "formatDate"
                                                          )(
                                                            _vm.details
                                                              .requestedExecutionDate
                                                          ),
                                                          labelClass: "mb-0",
                                                        },
                                                      }
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          (false &&
                            _vm.details.Attachments &&
                            _vm.details.Attachments.length > 0) ||
                          _vm.details.lettrage
                            ? _c(
                                "b-row",
                                { staticClass: "mt-2" },
                                [
                                  _vm.details.lettrage
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "transactionDetailSubHeader",
                                                  attrs: { cols: "12" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s("Lettrage") +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "mt-2",
                                                  attrs: { cols: "12" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.details.lettrage &&
                                                          _vm.details.lettrage
                                                            .length > 0
                                                          ? _vm.formatLettrage(
                                                              _vm.details
                                                                .lettrage
                                                            )
                                                          : "Pas de lettrage"
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.details.Attachments &&
                                  _vm.details.Attachments.length > 0
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "transactionDetailSubHeader",
                                                  attrs: { cols: "12" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s("Document") +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("document-list", {
                                            attrs: {
                                              documents:
                                                _vm.details.Attachments,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.status === _vm.status.REVOKED
                            ? _c("hr", { staticClass: "mx-auto" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.status === _vm.status.REVOKED
                            ? _c(
                                "form-accordion",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "common.formsSubTitle.refuse_reason"
                                    ),
                                    "font-size": "1rem",
                                  },
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(_vm.details.decisionMessage)
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.cancelMessage &&
                          _vm.details.cancelMessage !== ""
                            ? _c("hr", { staticClass: "mx-auto" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.cancelCode &&
                          _vm.details.cancelCode !== ""
                            ? _c(
                                "form-accordion",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "common.formsSubTitle.cancel_reason"
                                    ),
                                    "font-size": "1rem",
                                  },
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", [
                                        _c("p", [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.getCancelCodeLabel(
                                                    _vm.details.cancelCode
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _vm.details.cancelMessage &&
                                        _vm.details.cancelMessage !== ""
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.details.cancelMessage
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.direction === "0" &&
                          _vm.waitingForAnswerRTP(_vm.details.status) &&
                          _vm.details.acceptMultipleInstalments === "1"
                            ? _c("hr", { staticClass: "mx-auto" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.direction === "0" &&
                          _vm.waitingForAnswerRTP(_vm.details.status) &&
                          _vm.details.acceptMultipleInstalments === "1"
                            ? _c(
                                "form-accordion",
                                {
                                  attrs: {
                                    title: "ECHEANCIER",
                                    "font-size": "1rem",
                                  },
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              staticClass: "mt-sm-2",
                                              attrs: {
                                                value: true,
                                                "unchecked-value": false,
                                              },
                                              model: {
                                                value: _vm.showInstallments,
                                                callback: function ($$v) {
                                                  _vm.showInstallments = $$v
                                                },
                                                expression: "showInstallments",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.ask_multiple_payments_times"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.showInstallments
                                    ? _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: { sm: "6" },
                                            },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  attrs: {
                                                    inputType: "number",
                                                    inputLabel:
                                                      "Nombre d'échéances",
                                                  },
                                                  model: {
                                                    value: _vm.numInstallments,
                                                    callback: function ($$v) {
                                                      _vm.numInstallments = $$v
                                                    },
                                                    expression:
                                                      "numInstallments",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showInstallments
                                    ? _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c("echeancier", {
                                                attrs: {
                                                  numPay: _vm.numInstallments,
                                                  min: 1,
                                                  amount: _vm.details.amount,
                                                  ccy: "€",
                                                  deposit: 0,
                                                  execDate:
                                                    _vm.details
                                                      .requestedExecutionDate,
                                                },
                                                model: {
                                                  value: _vm.multPmts,
                                                  callback: function ($$v) {
                                                    _vm.multPmts = $$v
                                                  },
                                                  expression: "multPmts",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("hr", { staticClass: "mx-auto" }),
                          _vm._v(" "),
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "common.formsSubTitle.rqst_to_pay_hstry"
                                ),
                                open: true,
                                isTitleUpperCase: false,
                              },
                            },
                            [
                              _c(
                                "b-row",
                                { staticClass: "form-group" },
                                [
                                  _c("b-col", [
                                    _c(
                                      "table",
                                      { staticClass: "table text-center" },
                                      [
                                        _c("thead", [
                                          _c("tr", [
                                            _c("th", [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.date_request_label"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("th", [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.status.status_label"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _vm.fileFormat &&
                                            _vm.hasRight("xmlDetail_consulter")
                                              ? _c("th", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "requestToPay.stream_in"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.fileFormat &&
                                            _vm.hasRight("xmlDetail_consulter")
                                              ? _c("th", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "requestToPay.stream_out"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("th", [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "requestToPay.stream_out_status"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "tbody",
                                          _vm._l(
                                            _vm.details.history,
                                            function (record) {
                                              return _c(
                                                "tr",
                                                { key: record.id },
                                                [
                                                  (record.status !== "20" &&
                                                    _vm.isHRTP) ||
                                                  _vm.isSRTP ||
                                                  _vm.isPSD2
                                                    ? _c("td", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$options.filters.formatDateTime(
                                                                record.creationDate
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  (record.status !== "20" &&
                                                    _vm.isHRTP) ||
                                                  _vm.isSRTP ||
                                                  _vm.isPSD2
                                                    ? _c("td", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.getHistoryLabel(
                                                                record.status
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.fileFormat &&
                                                  _vm.hasRight(
                                                    "xmlDetail_consulter"
                                                  ) &&
                                                  ((record.status !== "20" &&
                                                    _vm.isHRTP) ||
                                                    _vm.isSRTP ||
                                                    _vm.isPSD2)
                                                    ? _c("td", [
                                                        !_vm.canSeeFormatIn(
                                                          record
                                                        )
                                                          ? _c("div", [
                                                              _vm._v("-"),
                                                            ])
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-xl-flex align-items-center justify-content-center",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      record
                                                                        .format
                                                                        .in.type
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                                _c("div", [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.seeXml(
                                                                            record
                                                                              .format
                                                                              .in,
                                                                            "requestToPay",
                                                                            "see"
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.seeXml(
                                                                            record
                                                                              .format
                                                                              .in,
                                                                            "requestToPay",
                                                                            "download"
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]
                                                            ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.fileFormat &&
                                                  _vm.hasRight(
                                                    "xmlDetail_consulter"
                                                  ) &&
                                                  ((record.status !== "20" &&
                                                    _vm.isHRTP) ||
                                                    _vm.isSRTP ||
                                                    _vm.isPSD2)
                                                    ? _c("td", [
                                                        !_vm.canSeeFormatOut(
                                                          record
                                                        )
                                                          ? _c("div", [
                                                              _vm._v("-"),
                                                            ])
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-xl-flex align-items-center justify-content-center",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      record
                                                                        .format
                                                                        .out
                                                                        .type
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                                _c("div", [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.seeXml(
                                                                            record
                                                                              .format
                                                                              .out,
                                                                            "requestToPay",
                                                                            "see"
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.seeXml(
                                                                            record
                                                                              .format
                                                                              .out,
                                                                            "requestToPay",
                                                                            "download"
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                ]),
                                                              ]
                                                            ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  (record.status !== "20" &&
                                                    _vm.isHRTP) ||
                                                  _vm.isSRTP ||
                                                  _vm.isPSD2
                                                    ? _c("td", [
                                                        record.format.out
                                                          .technicalCode ===
                                                        _vm.TECHNICAL_CODE.OK
                                                          ? _c("div", [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    record
                                                                      .format
                                                                      .out
                                                                      .technicalDescription
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-check px-2 color-var-actionButtonColorBlue",
                                                              }),
                                                              _vm._v(" "),
                                                              _vm.canSeeErrorBody(
                                                                record
                                                              )
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.seeXml(
                                                                            record
                                                                              .format
                                                                              .out,
                                                                            "requestToPay",
                                                                            "see",
                                                                            record.id
                                                                          )
                                                                        },
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.canSeeErrorBody(
                                                                record
                                                              )
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.seeXml(
                                                                            record
                                                                              .format
                                                                              .out,
                                                                            "requestToPay",
                                                                            "download",
                                                                            record.id
                                                                          )
                                                                        },
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          : record.format.out
                                                              .technicalCode ===
                                                            _vm.TECHNICAL_CODE
                                                              .KO
                                                          ? _c("div", [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    record
                                                                      .format
                                                                      .out
                                                                      .technicalDescription
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-xmark px-2 color-red",
                                                              }),
                                                              _vm._v(" "),
                                                              _vm.canSeeErrorBody(
                                                                record
                                                              )
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.seeXml(
                                                                            record
                                                                              .format
                                                                              .out,
                                                                            "requestToPay",
                                                                            "see",
                                                                            record.id
                                                                          )
                                                                        },
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.canSeeErrorBody(
                                                                record
                                                              )
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.seeXml(
                                                                            record
                                                                              .format
                                                                              .out,
                                                                            "requestToPay",
                                                                            "download",
                                                                            record.id
                                                                          )
                                                                        },
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ])
                                                          : record.format.out
                                                              .technicalCode ===
                                                            _vm.TECHNICAL_CODE
                                                              .NO_ANSWER
                                                          ? _c("div", [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    record
                                                                      .format
                                                                      .out
                                                                      .technicalDescription
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa-solid fa-plug-circle-xmark px-2 redIcon",
                                                              }),
                                                            ])
                                                          : _c("div", [
                                                              _vm._v("-"),
                                                            ]),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        [
                          _vm.canSeePaymentDetails && _vm.payments.length > 1
                            ? _c(
                                "f7-list",
                                [
                                  _c(
                                    "f7-list-item",
                                    { class: { "filter-item-section": true } },
                                    [
                                      _c(
                                        "b-row",
                                        {
                                          staticClass:
                                            "min-w-100 justify-content-start",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "filter-item col-3 mb-1",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "filter-item-title text-ellipsis",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "administration.transaction_identifier"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "filter-item-content",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.transactionIdFilter,
                                                        expression:
                                                          "transactionIdFilter",
                                                      },
                                                    ],
                                                    class: {
                                                      "filter-item-input": true,
                                                      "filter-item-input-complete":
                                                        _vm.transactionIdFilter,
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: _vm.$t(
                                                        "administration.transaction_identifier"
                                                      ),
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.transactionIdFilter,
                                                    },
                                                    on: {
                                                      input: [
                                                        function ($event) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.transactionIdFilter =
                                                            $event.target.value
                                                        },
                                                        function ($event) {
                                                          return _vm.delayApplyFilter()
                                                        },
                                                      ],
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "filter-item col-3 mb-1",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "filter-item-title text-ellipsis",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "common.amnt_installment_rtp"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "filter-item-content",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.amountFilter,
                                                        expression:
                                                          "amountFilter",
                                                      },
                                                    ],
                                                    class: {
                                                      "filter-item-input": true,
                                                      "filter-item-input-complete":
                                                        _vm.amountFilter,
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: _vm.$t(
                                                        "common.amnt_installment_rtp"
                                                      ),
                                                    },
                                                    domProps: {
                                                      value: _vm.amountFilter,
                                                    },
                                                    on: {
                                                      input: [
                                                        function ($event) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.amountFilter =
                                                            $event.target.value
                                                        },
                                                        function ($event) {
                                                          return _vm.delayApplyFilter()
                                                        },
                                                      ],
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "filter-item col-3 mb-1",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "filter-item-title text-ellipsis",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.status.payment_status_label"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "filter-item-content d-flex justify-content-between p-1 pt-2",
                                                  attrs: {
                                                    id:
                                                      "status-payment-picker-link" +
                                                      "-" +
                                                      _vm.randomStringStatusFilter,
                                                    href: "#",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      class:
                                                        "fixed-span-size " +
                                                        (_vm.statusDisplay.nb >
                                                        0
                                                          ? "filter-item-input-complete"
                                                          : ""),
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.statusDisplay
                                                            .label
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-light fa-chevron-down",
                                                    attrs: {
                                                      size: "17px",
                                                      id: "status-chevron",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-popover",
                                                {
                                                  attrs: {
                                                    target:
                                                      "status-payment-picker-link" +
                                                      "-" +
                                                      _vm.randomStringStatusFilter,
                                                    title: _vm.$t(
                                                      "filter.selected_status_none"
                                                    ),
                                                    triggers: "focus",
                                                    placement: "bottom",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    _vm._l(
                                                      _vm.statusList,
                                                      function (status, index) {
                                                        return _c(
                                                          "span",
                                                          {
                                                            key:
                                                              _vm.$t(
                                                                "common.status.payment." +
                                                                  status.id
                                                              ) +
                                                              "-" +
                                                              index,
                                                          },
                                                          [
                                                            _vm.arrayStatusListPayment.includes(
                                                              status.id
                                                            )
                                                              ? _c(
                                                                  "b-form-checkbox",
                                                                  {
                                                                    attrs: {
                                                                      value: 1,
                                                                      "unchecked-value": 0,
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.delayApplyFilter()
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        status.state,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            status,
                                                                            "state",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "status.state",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "font-weight-normal fs-13px",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "common.status.payment." +
                                                                                status.id
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between flex-row filter-item col-3 mt-4 mb-1 p-0",
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    disabled:
                                                      !_vm.hasInputFilter,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.clearFilterFields,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "filter.clr_fltr_field"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "ml-1",
                                                  attrs: { size: "sm" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.applyFilter()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("filter.fltr")
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.payments.length <= 1 &&
                          _vm.canSeePaymentDetails &&
                          !_vm.noPaymentsFiltered
                            ? _c(
                                "div",
                                [
                                  _vm.payments.length
                                    ? _c(
                                        "form-accordion",
                                        {
                                          staticClass: "px-2",
                                          attrs: {
                                            title: _vm.$t(
                                              "common.request_details"
                                            ),
                                            isTitleUpperCase: false,
                                          },
                                        },
                                        [
                                          _vm.payments.length
                                            ? _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    {
                                                      staticClass: "form-group",
                                                      attrs: {
                                                        xl: "3",
                                                        cols: "3",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "form-read-group-label-input",
                                                        {
                                                          attrs: {
                                                            inputLabel: _vm.$t(
                                                              "administration.message_identifier"
                                                            ),
                                                            colLabelSize: 4,
                                                            colInputSize: 8,
                                                            inputValue:
                                                              _vm.payments[0]
                                                                .msgId,
                                                            labelClass: "mb-0",
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      staticClass: "form-group",
                                                      attrs: {
                                                        xl: "3",
                                                        cols: "3",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "form-read-group-label-input",
                                                        {
                                                          attrs: {
                                                            inputLabel: _vm.$t(
                                                              "administration.transaction_identifier"
                                                            ),
                                                            colLabelSize: 4,
                                                            colInputSize: 8,
                                                            inputValue:
                                                              _vm.payments
                                                                .length &&
                                                              _vm.payments[0]
                                                                .TransactionId
                                                                ? _vm
                                                                    .payments[0]
                                                                    .TransactionId
                                                                : "-",
                                                            labelClass: "mb-0",
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    {
                                                      staticClass: "form-group",
                                                      attrs: {
                                                        xl: "3",
                                                        cols: "3",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "form-read-group-label-input",
                                                        {
                                                          attrs: {
                                                            inputLabel: _vm.$t(
                                                              "common.status.payment_status_label"
                                                            ),
                                                            colLabelSize: 4,
                                                            colInputSize: 8,
                                                            inputValue: _vm
                                                              .payments.length
                                                              ? _vm.getStatusLabel(
                                                                  _vm
                                                                    .payments[0]
                                                                    .status
                                                                )
                                                              : "-",
                                                            labelClass: "mb-0",
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "form-group",
                                                  attrs: { xl: "3", cols: "3" },
                                                },
                                                [
                                                  _c(
                                                    "form-read-group-label-input",
                                                    {
                                                      attrs: {
                                                        inputLabel:
                                                          _vm.$t(
                                                            "common.exec_date"
                                                          ),
                                                        colLabelSize: 4,
                                                        colInputSize: 8,
                                                        inputValue:
                                                          _vm.$options.filters.formatDateTime(
                                                            _vm.payments[0]
                                                              .executionDate
                                                          ),
                                                        labelClass: "mb-0",
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "form-group",
                                                  attrs: { xl: "3", cols: "3" },
                                                },
                                                [
                                                  _c(
                                                    "form-read-group-label-input",
                                                    {
                                                      attrs: {
                                                        inputLabel:
                                                          _vm.$t("common.amnt"),
                                                        colLabelSize: 4,
                                                        colInputSize: 8,
                                                        inputValue:
                                                          _vm.payments[0]
                                                            .amount +
                                                          " " +
                                                          _vm.zoneCodeToSign(),
                                                        labelClass: "mb-0",
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "form-group",
                                                  attrs: { xl: "3", cols: "3" },
                                                },
                                                [
                                                  _c(
                                                    "form-read-group-label-input",
                                                    {
                                                      attrs: {
                                                        inputLabel: _vm.$t(
                                                          "common.debtor_ibn_used"
                                                        ),
                                                        colLabelSize: 4,
                                                        colInputSize: 8,
                                                        inputValue:
                                                          _vm.payments[0]
                                                            .debtorBankAccount,
                                                        labelClass: "mb-0",
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.payments.length
                                    ? _c(
                                        "form-accordion",
                                        {
                                          staticClass: "px-2",
                                          attrs: {
                                            title: _vm.$t(
                                              "common.formsSubTitle.rqst_to_pay_hstry"
                                            ),
                                            open: true,
                                            isTitleUpperCase: false,
                                          },
                                        },
                                        [
                                          _c(
                                            "b-row",
                                            { staticClass: "form-group" },
                                            [
                                              _c("b-col", [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table text-center",
                                                  },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c("th", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.date_request_label"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("th", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.status.payment_status_label"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _vm.fileFormat &&
                                                        _vm.hasRight(
                                                          "xmlDetail_consulter"
                                                        )
                                                          ? _c("th", [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "requestToPay.stream_in"
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.fileFormat &&
                                                        _vm.hasRight(
                                                          "xmlDetail_consulter"
                                                        )
                                                          ? _c("th", [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "requestToPay.stream_out"
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("th", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "requestToPay.stream_out_status"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.payments[0].history,
                                                        function (record) {
                                                          return _c(
                                                            "tr",
                                                            { key: record.id },
                                                            [
                                                              (record.status !==
                                                                "20" &&
                                                                _vm.isHRTP) ||
                                                              _vm.isSRTP ||
                                                              _vm.isPSD2
                                                                ? _c("td", [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.$options.filters.formatDateTime(
                                                                            record.creationDate
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              (record.status !==
                                                                "20" &&
                                                                _vm.isHRTP) ||
                                                              _vm.isSRTP ||
                                                              _vm.isPSD2
                                                                ? _c("td", [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.getHistoryLabel(
                                                                            record.status
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.fileFormat &&
                                                              _vm.hasRight(
                                                                "xmlDetail_consulter"
                                                              ) &&
                                                              ((record.status !==
                                                                "20" &&
                                                                _vm.isHRTP) ||
                                                                _vm.isSRTP ||
                                                                _vm.isPSD2)
                                                                ? _c("td", [
                                                                    !_vm.canSeeFormatIn(
                                                                      record
                                                                    )
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _vm._v(
                                                                              "-"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "d-xl-flex align-items-center justify-content-center",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            " +
                                                                                _vm._s(
                                                                                  record
                                                                                    .format
                                                                                    .in
                                                                                    .type
                                                                                ) +
                                                                                "\n                            "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.seeXml(
                                                                                            record
                                                                                              .format
                                                                                              .in,
                                                                                            "payment",
                                                                                            "see"
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.seeXml(
                                                                                            record
                                                                                              .format
                                                                                              .in,
                                                                                            "payment",
                                                                                            "download"
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.fileFormat &&
                                                              _vm.hasRight(
                                                                "xmlDetail_consulter"
                                                              ) &&
                                                              ((record.status !==
                                                                "20" &&
                                                                _vm.isHRTP) ||
                                                                _vm.isSRTP ||
                                                                _vm.isPSD2)
                                                                ? _c("td", [
                                                                    !_vm.canSeeFormatOut(
                                                                      record
                                                                    )
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _vm._v(
                                                                              "-"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "d-xl-flex align-items-center justify-content-center",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            " +
                                                                                _vm._s(
                                                                                  record
                                                                                    .format
                                                                                    .out
                                                                                    .type
                                                                                ) +
                                                                                "\n                            "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.seeXml(
                                                                                            record
                                                                                              .format
                                                                                              .out,
                                                                                            "payment",
                                                                                            "see"
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.seeXml(
                                                                                            record
                                                                                              .format
                                                                                              .out,
                                                                                            "payment",
                                                                                            "download"
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              (record.status !==
                                                                "20" &&
                                                                _vm.isHRTP) ||
                                                              _vm.isSRTP ||
                                                              _vm.isPSD2
                                                                ? _c("td", [
                                                                    record
                                                                      .format
                                                                      .out
                                                                      .technicalCode ===
                                                                    _vm
                                                                      .TECHNICAL_CODE
                                                                      .OK
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    record
                                                                                      .format
                                                                                      .out
                                                                                      .technicalDescription
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fa fa-check px-2 color-var-actionButtonColorBlue",
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _vm.canSeeErrorBody(
                                                                              record
                                                                            )
                                                                              ? _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.seeXml(
                                                                                            record
                                                                                              .format
                                                                                              .out,
                                                                                            "payment",
                                                                                            "see",
                                                                                            record.id
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _vm.canSeeErrorBody(
                                                                              record
                                                                            )
                                                                              ? _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.seeXml(
                                                                                            record
                                                                                              .format
                                                                                              .out,
                                                                                            "payment",
                                                                                            "download",
                                                                                            record.id
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        )
                                                                      : record
                                                                          .format
                                                                          .out
                                                                          .technicalCode ===
                                                                        _vm
                                                                          .TECHNICAL_CODE
                                                                          .KO
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    record
                                                                                      .format
                                                                                      .out
                                                                                      .technicalDescription
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fa fa-xmark px-2 color-red",
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _vm.canSeeErrorBody(
                                                                              record
                                                                            )
                                                                              ? _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.seeXml(
                                                                                            record
                                                                                              .format
                                                                                              .out,
                                                                                            "payment",
                                                                                            "see",
                                                                                            record.id
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _vm.canSeeErrorBody(
                                                                              record
                                                                            )
                                                                              ? _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.seeXml(
                                                                                            record
                                                                                              .format
                                                                                              .out,
                                                                                            "payment",
                                                                                            "download",
                                                                                            record.id
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        )
                                                                      : record
                                                                          .format
                                                                          .out
                                                                          .technicalCode ===
                                                                        _vm
                                                                          .TECHNICAL_CODE
                                                                          .NO_ANSWER
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    record
                                                                                      .format
                                                                                      .out
                                                                                      .technicalDescription
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fa-solid fa-plug-circle-xmark px-2 redIcon",
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "div",
                                                                          [
                                                                            _vm._v(
                                                                              "-"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ])
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm.canSeePaymentDetails &&
                              !_vm.noPaymentsFiltered
                            ? _c(
                                "div",
                                { staticClass: "panel-reverse-margin" },
                                _vm._l(_vm.payments, function (payment, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: payment.id,
                                      staticClass:
                                        "counter-panel-reverse-margin",
                                      class: _vm.getBgColor(index),
                                    },
                                    [
                                      Object.keys(payment).length > 0
                                        ? _c(
                                            "form-accordion",
                                            {
                                              staticClass: "py-3",
                                              attrs: {
                                                title:
                                                  _vm.$t("common.payment") +
                                                  " " +
                                                  (index + 1),
                                                isTitleUpperCase: false,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "px-2" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "form-group titleAccordion font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.request_details"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    { staticClass: "mt-3" },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          staticClass:
                                                            "form-group",
                                                          attrs: {
                                                            xl: "3",
                                                            cols: "3",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "form-read-group-label-input",
                                                            {
                                                              attrs: {
                                                                inputLabel:
                                                                  _vm.$t(
                                                                    "administration.message_identifier"
                                                                  ),
                                                                colLabelSize: 4,
                                                                colInputSize: 8,
                                                                inputValue:
                                                                  payment.msgId,
                                                                labelClass:
                                                                  "mb-0",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          staticClass:
                                                            "form-group",
                                                          attrs: {
                                                            xl: "3",
                                                            cols: "3",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "form-read-group-label-input",
                                                            {
                                                              attrs: {
                                                                inputLabel:
                                                                  _vm.$t(
                                                                    "administration.transaction_identifier"
                                                                  ),
                                                                colLabelSize: 4,
                                                                colInputSize: 8,
                                                                inputValue:
                                                                  payment.TransactionId ===
                                                                  ""
                                                                    ? "-"
                                                                    : payment.TransactionId,
                                                                labelClass:
                                                                  "mb-0",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          staticClass:
                                                            "form-group",
                                                          attrs: {
                                                            xl: "3",
                                                            cols: "3",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "form-read-group-label-input",
                                                            {
                                                              attrs: {
                                                                inputLabel:
                                                                  _vm.$t(
                                                                    "common.status.payment_status_label"
                                                                  ),
                                                                colLabelSize: 4,
                                                                colInputSize: 8,
                                                                inputValue:
                                                                  _vm.getStatusLabel(
                                                                    payment.status
                                                                  ),
                                                                labelClass:
                                                                  "mb-0",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          staticClass:
                                                            "form-group",
                                                          attrs: {
                                                            xl: "3",
                                                            cols: "3",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "form-read-group-label-input",
                                                            {
                                                              attrs: {
                                                                inputLabel:
                                                                  _vm.$t(
                                                                    "common.exec_date"
                                                                  ),
                                                                colLabelSize: 4,
                                                                colInputSize: 8,
                                                                inputValue:
                                                                  _vm.$options.filters.formatDateTime(
                                                                    payment.executionDate
                                                                  ),
                                                                labelClass:
                                                                  "mb-0",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          staticClass:
                                                            "form-group",
                                                          attrs: {
                                                            xl: "3",
                                                            cols: "3",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "form-read-group-label-input",
                                                            {
                                                              attrs: {
                                                                inputLabel:
                                                                  _vm.$t(
                                                                    "common.amnt"
                                                                  ),
                                                                colLabelSize: 4,
                                                                colInputSize: 8,
                                                                inputValue:
                                                                  payment.amount +
                                                                  " " +
                                                                  _vm.zoneCodeToSign(),
                                                                labelClass:
                                                                  "mb-0",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          staticClass:
                                                            "form-group",
                                                          attrs: {
                                                            xl: "3",
                                                            cols: "3",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "form-read-group-label-input",
                                                            {
                                                              attrs: {
                                                                inputLabel:
                                                                  _vm.$t(
                                                                    "common.debtor_ibn_used"
                                                                  ),
                                                                colLabelSize: 4,
                                                                colInputSize: 8,
                                                                inputValue:
                                                                  payment.debtorBankAccount,
                                                                labelClass:
                                                                  "mb-0",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "px-2" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "form-group titleAccordion font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.formsSubTitle.rqst_to_pay_hstry"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    {
                                                      staticClass:
                                                        "mt-3 form-group",
                                                    },
                                                    [
                                                      _c("b-col", [
                                                        _c(
                                                          "table",
                                                          {
                                                            staticClass:
                                                              "table text-center",
                                                          },
                                                          [
                                                            _c("thead", [
                                                              _c("tr", [
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "common.date_request_label"
                                                                        )
                                                                      ) +
                                                                      "\n                            "
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "common.status.payment_status_label"
                                                                        )
                                                                      ) +
                                                                      "\n                            "
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _vm.fileFormat &&
                                                                _vm.hasRight(
                                                                  "xmlDetail_consulter"
                                                                )
                                                                  ? _c("th", [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "requestToPay.stream_in"
                                                                            )
                                                                          ) +
                                                                          "\n                            "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _vm.fileFormat &&
                                                                _vm.hasRight(
                                                                  "xmlDetail_consulter"
                                                                )
                                                                  ? _c("th", [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "requestToPay.stream_out"
                                                                            )
                                                                          ) +
                                                                          "\n                            "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "requestToPay.stream_out_status"
                                                                        )
                                                                      ) +
                                                                      "\n                            "
                                                                  ),
                                                                ]),
                                                              ]),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "tbody",
                                                              _vm._l(
                                                                payment.history,
                                                                function (
                                                                  record
                                                                ) {
                                                                  return _c(
                                                                    "tr",
                                                                    {
                                                                      key: record.id,
                                                                    },
                                                                    [
                                                                      (record.status !==
                                                                        "20" &&
                                                                        _vm.isHRTP) ||
                                                                      _vm.isSRTP
                                                                        ? _c(
                                                                            "td",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.$options.filters.formatDateTime(
                                                                                      record.creationDate
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      (record.status !==
                                                                        "20" &&
                                                                        _vm.isHRTP) ||
                                                                      _vm.isSRTP
                                                                        ? _c(
                                                                            "td",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                              " +
                                                                                  _vm._s(
                                                                                    _vm.getHistoryLabel(
                                                                                      record.status
                                                                                    )
                                                                                  ) +
                                                                                  "\n                            "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm.fileFormat &&
                                                                      _vm.hasRight(
                                                                        "xmlDetail_consulter"
                                                                      ) &&
                                                                      ((record.status !==
                                                                        "20" &&
                                                                        _vm.isHRTP) ||
                                                                        _vm.isSRTP ||
                                                                        _vm.isPSD2)
                                                                        ? _c(
                                                                            "td",
                                                                            [
                                                                              !_vm.canSeeFormatIn(
                                                                                record
                                                                              )
                                                                                ? _c(
                                                                                    "div",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "-"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "d-xl-flex align-items-center justify-content-center",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                " +
                                                                                          _vm._s(
                                                                                            record
                                                                                              .format
                                                                                              .in
                                                                                              .type
                                                                                          ) +
                                                                                          "\n                                "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        [
                                                                                          _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.seeXml(
                                                                                                      record
                                                                                                        .format
                                                                                                        .in,
                                                                                                      "payment",
                                                                                                      "see"
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            }
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.seeXml(
                                                                                                      record
                                                                                                        .format
                                                                                                        .in,
                                                                                                      "payment",
                                                                                                      "download"
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm.fileFormat &&
                                                                      _vm.hasRight(
                                                                        "xmlDetail_consulter"
                                                                      ) &&
                                                                      ((record.status !==
                                                                        "20" &&
                                                                        _vm.isHRTP) ||
                                                                        _vm.isSRTP ||
                                                                        _vm.isPSD2)
                                                                        ? _c(
                                                                            "td",
                                                                            [
                                                                              !_vm.canSeeFormatOut(
                                                                                record
                                                                              )
                                                                                ? _c(
                                                                                    "div",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "-"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "d-xl-flex align-items-center justify-content-center",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                " +
                                                                                          _vm._s(
                                                                                            record
                                                                                              .format
                                                                                              .out
                                                                                              .type
                                                                                          ) +
                                                                                          "\n                                "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        [
                                                                                          _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.seeXml(
                                                                                                      record
                                                                                                        .format
                                                                                                        .out,
                                                                                                      "payment",
                                                                                                      "see"
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            }
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.seeXml(
                                                                                                      record
                                                                                                        .format
                                                                                                        .out,
                                                                                                      "payment",
                                                                                                      "download"
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      (record.status !==
                                                                        "20" &&
                                                                        _vm.isHRTP) ||
                                                                      _vm.isSRTP ||
                                                                      _vm.isPSD2
                                                                        ? _c(
                                                                            "td",
                                                                            [
                                                                              record
                                                                                .format
                                                                                .out
                                                                                .technicalCode ===
                                                                              _vm
                                                                                .TECHNICAL_CODE
                                                                                .OK
                                                                                ? _c(
                                                                                    "div",
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              record
                                                                                                .format
                                                                                                .out
                                                                                                .technicalDescription
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "i",
                                                                                        {
                                                                                          staticClass:
                                                                                            "fa fa-check px-2 color-var-actionButtonColorBlue",
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _vm.canSeeErrorBody(
                                                                                        record
                                                                                      )
                                                                                        ? _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.seeXml(
                                                                                                      record
                                                                                                        .format
                                                                                                        .out,
                                                                                                      "payment",
                                                                                                      "see"
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            }
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _vm.canSeeErrorBody(
                                                                                        record
                                                                                      )
                                                                                        ? _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.seeXml(
                                                                                                      record
                                                                                                        .format
                                                                                                        .out,
                                                                                                      "payment",
                                                                                                      "download"
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            }
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  )
                                                                                : record
                                                                                    .format
                                                                                    .out
                                                                                    .technicalCode ===
                                                                                  _vm
                                                                                    .TECHNICAL_CODE
                                                                                    .KO
                                                                                ? _c(
                                                                                    "div",
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              record
                                                                                                .format
                                                                                                .out
                                                                                                .technicalDescription
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "i",
                                                                                        {
                                                                                          staticClass:
                                                                                            "fa fa-xmark px-2 color-red",
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _vm.canSeeErrorBody(
                                                                                        record
                                                                                      )
                                                                                        ? _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-eye cursor px-2 color-var-actionButtonColorBlue",
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.seeXml(
                                                                                                      record
                                                                                                        .format
                                                                                                        .out,
                                                                                                      "payment",
                                                                                                      "see"
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            }
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _vm.canSeeErrorBody(
                                                                                        record
                                                                                      )
                                                                                        ? _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-download cursor px-2 color-var-actionButtonColorBlue",
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.seeXml(
                                                                                                      record
                                                                                                        .format
                                                                                                        .out,
                                                                                                      "payment",
                                                                                                      "download"
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                            }
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  )
                                                                                : record
                                                                                    .format
                                                                                    .out
                                                                                    .technicalCode ===
                                                                                  _vm
                                                                                    .TECHNICAL_CODE
                                                                                    .NO_ANSWER
                                                                                ? _c(
                                                                                    "div",
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              record
                                                                                                .format
                                                                                                .out
                                                                                                .technicalDescription
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "i",
                                                                                        {
                                                                                          staticClass:
                                                                                            "fa-solid fa-plug-circle-xmark px-2 redIcon",
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "div",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "-"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "font-bold w-100 d-flex justify-content-center mt-3",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.no_payment")))]
                                ),
                              ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.activateSpinner
            ? _c(
                "div",
                {
                  staticClass: "ml-3 mr-3",
                  attrs: { slot: "footerButtons" },
                  slot: "footerButtons",
                },
                [
                  !_vm.details.id ||
                  (_vm.showOtherDebtors() && _vm.otherRTP.length === 0)
                    ? _c("div")
                    : _c(
                        "div",
                        [
                          _vm.details.direction === "0"
                            ? _c(
                                "b-row",
                                { staticClass: "inboxDetailButton" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "10", "offset-md": "2" } },
                                    [
                                      _c(
                                        "b-row",
                                        {
                                          staticClass:
                                            "justify-content-end no-gutters",
                                        },
                                        [
                                          _vm.showButtonInvalidAccount &&
                                          _vm.isHRTP
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass: "mx-2",
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                  },
                                                  on: {
                                                    click: _vm.payerNotFound,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.invalid_account"
                                                        )
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showButtonRefuse && _vm.isSRTP
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass: "mx-2",
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.transactionRefused,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t("common.refus")
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showButtonRefuse && _vm.isHRTP
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass: "mx-2",
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.transactionRefused,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.refus_hrtp"
                                                        )
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showButtonPay
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass: "mx-2",
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.pay()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t("common.pay")
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showButtonPaymentValidate
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass: "mx-2",
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                  },
                                                  on: {
                                                    click: _vm.payementRejected,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.payment_reject"
                                                        )
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showButtonPaymentValidate
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass: "mx-2",
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.payementValidated,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.payment_validate"
                                                        )
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showButtonAcceptAndPay &&
                                          _vm.isSRTP
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass: "mx-2",
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.transactionAcceptedAndPay,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.accpt_nd_pay"
                                                        )
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showButtonAccept && _vm.isHRTP
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass: "mx-2",
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                  },
                                                  on: {
                                                    click: _vm.buttonAccept,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.accpt_hrtp"
                                                        )
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showButtonAccept && _vm.isSRTP
                                            ? _c(
                                                "b-button",
                                                {
                                                  staticClass: "mx-2",
                                                  attrs: {
                                                    variant: "primary",
                                                    size: "lg",
                                                  },
                                                  on: {
                                                    click: _vm.buttonAccept,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t("common.accpt")
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.direction === "1" &&
                          ["1", "5", "9", "10"].includes(_vm.details.status)
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "justify-content-end no-gutters",
                                    },
                                    [
                                      _vm.isHRTP && _vm.showButtonCancel
                                        ? _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant: "primary",
                                                size: "lg",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.cancelRequestToPay(
                                                    _vm.details.endToEndId,
                                                    "SL02",
                                                    "Code"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "requestToPay.cancel_rtp_hrtp"
                                                    )
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          )
                                        : _vm.isSRTP && _vm.showButtonCancel
                                        ? _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant: "primary",
                                                size: "lg",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.cancelRequestToPay(
                                                    _vm.details.endToEndId
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "requestToPay.cancel_rtp"
                                                    )
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }